module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select_local_delivery":"Select delivery service","motorcycle":"Motorcycle","car":"Car"},"id":{"select_local_delivery":"Pilih layanan pengiriman","motorcycle":"Sepeda motor","car":"Mobil"}}')
  delete Component.options._Ctor
}
